// @flow
import { Selector } from "../../utils/selectorUtils";
import PatientModel from "../../models/PatientModel";

class PatientSelector extends Selector<PatientModel> {}

export default new PatientSelector("patients", new PatientModel());
